import { createApi } from "@reduxjs/toolkit/query/react";
import {
  SalesOrderSearchResult,
  SalesOrderSearch,
  SalesOrderSummaryResult,
  DeleteResponse
} from "@/types/amazon/amazonSalesOrder";
import { marketPlaceBaseQueryWrapper } from "@/utils/rtkHelper";

export const AmazonSalesOrderApi = createApi({
  reducerPath: "AmazonSalesOrderApi",
  baseQuery: marketPlaceBaseQueryWrapper,
  tagTypes: ["amazonSalesOrder"],
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    uploadSalesOrder: builder.mutation({
      query: ({ formData }) => ({
        url: `/amazonsalesorder/xlsx`,
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["amazonSalesOrder"],
    }),
    searchOrders: builder.query<SalesOrderSearchResult, SalesOrderSearch>({
      query: (input) => ({
        url: `/amazonsalesorder/search`,
        method: "POST",
        body: { ...input, export: false },
      }),
      providesTags: ["amazonSalesOrder"],
    }),
    exportSalesOrder: builder.mutation<Blob, SalesOrderSearch>({
      query: (input) => ({
        url: `/amazonsalesorder/search`,
        method: "POST",
        body: { ...input, export: true },
        responseHandler: (response: Response) => response.blob(),
      }),
    }),
    summaryOrders: builder.query<SalesOrderSummaryResult, SalesOrderSearch>({
      query: (input) => ({
        url: `/amazonsalesorder/salesorder_summary`,
        method: "POST",
        body: input,
      }),
      providesTags: ["amazonSalesOrder"],
    }),
    deleteSalesReturns: builder.mutation<DeleteResponse, string[]>({
      query: (ids) => ({
        url: "/amazonsalesorder/delete",
        method: "DELETE",
        body: { ids },
      }),
      invalidatesTags: ["amazonSalesOrder"],
    }),
  }),
});

export const {
  useUploadSalesOrderMutation,
  useSearchOrdersQuery,
  useLazySearchOrdersQuery,
  useExportSalesOrderMutation,
  useSummaryOrdersQuery,
  useDeleteSalesReturnsMutation,
} = AmazonSalesOrderApi;
